export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const SET_ACCESS_TOKEN = 'setAccessToken'
export const DESTROY_TOKEN = 'destroyToken'